<template>
  <div class="root">
    <p class="section-title">
      <img src="@/assets/kutikomi.svg" />
      口コミ
    </p>
    <ReviewArea :comments="comments" />
    <ReviewDialog />
  </div>
</template>

<script>
import ReviewDialog from "@/components/DropSpotSelectModal/ReviewDialog";
import ReviewArea from "@/components/DropSpotSelectModal/ReviewArea";

export default {
  name: "review-area-root",
  components: {
    ReviewDialog,
    ReviewArea,
  },
  props: {
    comments: {
      type: Array,
      require: true,
    },
  },
  data() {
    return {};
  },
  computed: {},
  methods: {},
  mounted() {},
};
</script>

<style lang="scss" scoped>
@import "./../../unified.scss";

.root {
  margin: 2rem 0;
  padding: 0 1.25rem;
  .section-title {
    display: flex;
    align-items: center;
    margin: 0.5rem 0;
    img {
      margin-right: 0.5rem;
      width: 20px;
    }
    p {
      line-height: 20px;
    }
  }

  ul {
    list-style: none;
    padding-left: 0;
    border-bottom: 1px #e7e7e7 solid;
    margin: 0.5rem 0;
    li {
      font-size: 0.9rem;
      margin: 0;
      padding: 0.5rem 0;
      border-top: #e7e7e7 1px solid;
    }
  }
  a,
  a:visited,
  a:hover,
  a:active {
    color: #5cd5d6;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DropSpotSelectModal/ReviewAreaRoot.vue